import type {
  Hero as IHeroProps,
  StoreHero as IStoreHero,
} from '@cinch-nx/data-storyblok'
import {
  GenericHero,
  HeroWithRichText,
  type IHeroWithRichTextProps,
  LandingHero,
  StoreHero,
  HeroSection,
  type HeroSectionProps,
} from './variants'
import { LandingHeroProps } from './variants/landing-hero/landing-hero'

export interface IHeroComponentProps {
  heroProps:
    | IHeroProps
    | IHeroWithRichTextProps
    | IStoreHero
    | LandingHeroProps
    | undefined
}

export const Hero = ({ heroProps }: IHeroComponentProps) => {
  switch (heroProps?.component) {
    case 'GenericHero': {
      return <GenericHero {...(heroProps as IHeroProps)} />
    }
    case 'CarFinanceHero': {
      return <HeroWithRichText {...(heroProps as IHeroWithRichTextProps)} />
    }
    case 'StoreHero': {
      return <StoreHero {...(heroProps as IStoreHero)} />
    }
    case 'LandingHero': {
      return <LandingHero {...(heroProps as LandingHeroProps)} />
    }
    case 'HeroSection': {
      return <HeroSection {...(heroProps as HeroSectionProps)} />
    }
    default: {
      return null
    }
  }
}
